import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Header from "../common/Header";
import AssignedRoles from "./AssignedRoles";
import CareerHistory from "./CareerHistory";
import CertificateOfQualification from "./CertificateOfQualification";
import Education from "./Education";
import ExperienceStudies from "./ExperienceStudies";
import OtherExperience from "./OtherExperience";

export default function CurriculumVitae() {
  const userInfo = useSelector((state) => state.userInfo);

  useEffect(() => {
    document.title = "CV";
  }, []);

  return (
    <React.Fragment>
      <Header title="CURRICULUM VITAE" menudataSource={null} />
      <AssignedRoles />
      <Education />
      <CareerHistory />
      <ExperienceStudies />
      <CertificateOfQualification />
      <OtherExperience />
    </React.Fragment>
  );
}
